import React, { useEffect, useRef, useState } from 'react'
import './transcript-download-button.styles.scss';
import { getActivityLogsFromDb, getCompiledDataFromDb, getRealTimeQueryFromDb } from '@/utils/getDataFromDb';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faRefresh } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import CsvDownload from 'react-json-to-csv';
import { format } from 'date-fns';

const TranscriptDownloadButton = ({
    user,
    mcList
}) => {

    const [ transcriptLoading, setTranscriptLoading ] = useState(false);
    const [ transcriptData, setTranscriptData ] = useState(null);
    const transcriptRef = useRef(null);

    useEffect(() => {
        console.log(user);
    }, [user])

    useEffect(() => {
        if (!transcriptData) return;
        document.getElementById('csv-download-button').click();
        setTranscriptLoading(false);
    }, [transcriptData])

    async function getTranscript() {
        setTranscriptLoading(true);
        getCompiledDataFromDb({
            'cst_key': user.cst_key,
            'once': true,
            'callback': callback
        })
        function callback(data) {
            console.log(data);
            let dataObj = {};
            for (let mc of Object.values(mcList)) {
                let obj = {
                    'User Name': `${user.lName}, ${user.fName}`,
                    'User Email': user.email,
                    'User ID': user.recno ?? user.cst_key,
                    'MC Name': mc.name,
                    'MC ID': mc.mc_key,
                    'Materials Accepted': null,
                    'Precheck Submitted': null,
                    'Precheck Approved': null,
                    'Portfolio Submitted': null,
                    'Portfolio Approved': null
                }
                dataObj[mc.mc_key] = obj;
            }
            console.log(dataObj);
            for (let d of Object.values(data)) {
                if (!dataObj[d.mc_key]) continue;
                const dateString = format(new Date(d.ts), "P");
                // if (d.type === 'progress-purchased') {
                //     dataObj[d.mc_key]['Purchased'] = dateString;
                // }
                if (d.type === 'materials-accepted') {
                    dataObj[d.mc_key]['Materials'] = dateString;
                }
                else if (d.type === 'precheck-submitted') {
                    dataObj[d.mc_key]['Precheck Submitted'] = dateString;
                }
                else if (d.type === 'precheck-approved') {
                    dataObj[d.mc_key]['Precheck Approved'] = dateString;
                }
                else if (d.type === 'portfolio-submitted') {
                    dataObj[d.mc_key]['Portfolio Submitted'] = dateString;
                }
                else if (d.type === 'portfolio-approved') {
                    dataObj[d.mc_key]['Portfolio Approved'] = dateString;
                }
            }
            transcriptRef.current = Object.values(dataObj);
            setTranscriptData(transcriptRef.current);
            
        }
    }

    return (
        <div className='transcript-download-button'>
            {
                (transcriptData) &&
                <CsvDownload
                    id='csv-download-button'
                    data={transcriptData}
                    filename={`${user.lName}${user.fName[0]}_eln_mctranscript_${(format(new Date(), "Pp")).replace(/[^A-Za-z0-9]/g, '')}.csv`}
                    className='hide g-button small-btn'
                    delimiter=','
                    title='Download Transcript'>
                    <FontAwesomeIcon icon={faDownload} />
                </CsvDownload>
            }
            <button 
                className={`g-button small-btn ${transcriptLoading ? 'disabled' : ''}`}
                onClick={() => getTranscript()}>
                {
                    (transcriptLoading)
                    ?
                    <>Download Transcript<FontAwesomeIcon icon={faRefresh} className='spinning-icon' /></>
                    :
                    <>Download Transcript<FontAwesomeIcon icon={faDownload} /></>
                }
            </button>
        </div>
    )
}

export default TranscriptDownloadButton